var utils = {
    isEmptyObject(obj) {
        if(obj == undefined || obj == null){
            return true
        }
        for (var i in obj) {
            return false;
        }
        return true;
    },
    isEmptyStr(str) {
        return str == undefined || str == null || str.length == 0;
    },
      //获取url参数对象
    getRequest(url) {
        var params = {};
        if (url.indexOf('?') == -1){
        return params
        }
        var urls = url.split("?");
        var arr = urls[1].split("&");
        for (var i = 0, l = arr.length; i < l; i++) {
        var a = arr[i].split("=");
        params[a[0]] = a[1];
        }
        return params
    },
    formatTimeMonth() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      return [year, month].map(this.formatNumber).join('-')
    },
    formatNumber(n) {
            n = n.toString()
            return n[1] ? n : '0' + n
    },
    formatTimeDay() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate()
      return [year, month, day].map(this.formatNumber).join('-')
    },
    formatNumber(n) {
      n = n.toString()
      return n[1] ? n : '0' + n
    },
    afterDateFromCurrent(val1) {
      var arr1 = val1.split('-')
      var arr2 = this.formatTimeDay().split('-')
      if(parseInt(arr1[0]) > parseInt(arr2[0])){
        return true
      }else if(parseInt(arr1[0]) < parseInt(arr2[0])){
        return false
      }else{
        if(parseInt(arr1[1]) > parseInt(arr2[1])){
          return true
        }else if(parseInt(arr1[1]) < parseInt(arr2[1])){
          return false
        }else{
          if(parseInt(arr1[2]) >= parseInt(arr2[2])){
            return true
          }else{
            return false
          }
        }
      }
    },
    isAfterOneYear(value){
      var arr = value.split('-')
      var date1 = new Date();
      var date2 = new Date(parseInt(arr[0])-1, parseInt(arr[1])-1, parseInt(arr[2]));
      console.log(date1)
      console.log(date2)
      return (date1<date2)
    }
}
export default utils



// WEBPACK FOOTER //
// ./src/js/utils.js